import { useTheme } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import React from "react";

const IconWithText = ({
  component,
  color,
  title = "",
  subTitle = "",
  styles = {},
}) => {
  const theme = useTheme();
  const Component = component;
  return (
    <>
      <div className="col-auto desktop-only">
        <Component
          sx={{
            width: "5vw",
            height: "8vh",
            color: color,
            ...styles,
          }}
        />
      </div>
      <div className="col-auto">
        <div className="col-auto mobile-only" style={{marginRight: "15px", float: "left"}}>
          <Component
            sx={{
              width: "5vw",
              height: "8vh",
              color: color,
              ...styles,
            }}
          />
        </div>
        <div
          className="text-md-center text-lg-start"
          style={{ fontWeight: "bold", fontFamily: "noto-sans" }}
        >
          {title}
        </div>
        <div className={"mobile-only"} style={{ fontFamily: "noto-sans", float: "right", marginLeft: "45px", marginBottom: "25px" }}>{subTitle}</div>
        <div className={"desktop-only"} style={{ fontFamily: "noto-sans"}}>{subTitle}</div>
      </div>
    </>
  );
};

export default IconWithText;
